import { useRuntimeConfig } from '#imports'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { VENDORS_ID } from '../didomi/config'

export function useDataConsent() {
  const { market } = useMarketplace()
  const { didomi } = useRuntimeConfig().public.tracking

  const logger = useLogger()
  const isDidomiEnabled =
    didomi.isEnabled && didomi.enabledCountryCodes.includes(market.countryCode)

  function showNotice() {
    if (!process.client) return

    window.Didomi?.preferences.show()
  }

  function getUserConsentForVendor(vendor: string): boolean {
    try {
      if (!isDidomiEnabled || !process.client || !window.Didomi) return false

      return window.Didomi.getCurrentUserStatus().vendors[vendor].enabled
    } catch (error) {
      logger.error(`[Didomi] Error getting user consent for vendor ${vendor}`, {
        error: error as Error,
        owners: ['bot-group-onboard-front'],
      })

      return false
    }
  }

  function getUserConsentForAmplitude() {
    return getUserConsentForVendor(VENDORS_ID.amplitude)
  }

  return {
    showNotice,
    getUserConsentForAmplitude,
    isDidomiEnabled,
  }
}
